<script setup lang="ts">
import { useGiveaway } from '@/composables/game/giveaway'
import { twMerge } from 'tailwind-merge'

withDefaults(defineProps<{
  pulsate?: boolean
  isSingle?: boolean
  hasTag?: boolean
}>(), {
  pulsate: false,
  isSingle: false,
  hasTag: true,
})

const { countdown } = useGiveaway()
</script>

<template>
  <div :class="twMerge('w-max h-full relative overflow-hidden', pulsate && 'scale-up', isSingle && 'banner-container')">
    <div
      v-if="hasTag"
      class="absolute top-1.5 right-1.5 h-max w-max rounded-[38px] p-[1px] live-chip-border flex items-center justify-center z-[1]"
    >
      <div class="flex items-center gap-x-1 bg-[#010101] rounded-[38px] px-1 py-0.5 w-max">
        <div
          class="rounded-full size-1"
          :class="countdown ? 'bg-green-primary blink-in-out' : 'bg-[#999999]'"
        />
        <span
          class="uppercase text-white font-bold text-[10px] leading-[10px] -tracking-[0.2px] w-5"
        >
          {{ countdown ? 'Live' : 'Ended' }}
        </span>
      </div>
    </div>
    <div class="flex items-center justify-center w-full h-full">
      <img
        class="w-auto h-full object-cover"
        src="../assets/images/carousel-banners/lucky-rush-banner.png"
      >
    </div>

    <div class="absolute top-1/2 left-1/2 overflow-hidden flex items-center justify-center  ticket-transform">
      <img
        src="@/assets/images/gifs/ticket.gif"
        class="size-[250px] min-w-[250px]"
      >
    </div>
    <img
      class="absolute bottom-4 left-1/2 -translate-x-1/2 h-[50%] z-[1]"
      src="../assets/images/carousel-banners/lucky-rush-banner-text.png"
    >
  </div>
</template>

<style scoped>
.gradient-border-image {
  border-radius: 12px; /* 12px border radius for both the image and the border */
  /* Background image */
  background-image: url("@/partners/lingo/lingo-giveaway/assets/images/lingo-banner.png");
}

.shine {
  /*   positioning */
  position: absolute;
  opacity: 0;
  top: -2px;
  left: -15px;

  /*   gradient   */
  background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* FF3.6+ */
  background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(255, 255, 255, 0)), color-stop(1%, rgba(255, 255, 255, 0.03)), color-stop(30%, rgba(255, 255, 255, 0.85)), color-stop(50%, rgba(255, 255, 255, 0.85)), color-stop(70%, rgba(255, 255, 255, 0.85)), color-stop(71%, rgba(255, 255, 255, 0.85)), color-stop(100%, rgba(255, 255, 255, 0))); /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* Opera 11.10+ */
  background: -ms-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* IE10+ */
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.03) 1%, rgba(255, 255, 255, 0.6) 30%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.85) 71%, rgba(255, 255, 255, 0) 100%); /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#00ffffff', GradientType=1); /* IE6-9 */

  /*  forming the shine element
      play around with the width, skew and gradient to get different effects
    */
  width: 12%;
  z-index: 1;
  height: calc(100% + 4px);
  transform: skew(-10deg, 0deg);
  -webkit-transform: skew(-10deg, 0deg);
  -moz-transform: skew(-10deg, 0deg);
  -ms-transform: skew(-10deg, 0deg);
  -o-transform: skew(-10deg, 0deg);

  /*  animating it  */
  animation-name: move-shine;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  -webkit-animation-name: move-shine;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  -moz-transform: skew(-10deg, 0deg);
  -moz-animation-name: move-shine;
  -moz-animation-duration: 2s;
  -moz-animation-iteration-count: infinite;
  -ms-transform: skew(-10deg, 0deg);
  -ms-animation-name: move-shine;
  -ms-animation-duration: 2s;
  -ms-animation-iteration-count: infinite;
  -o-transform: skew(-10deg, 0deg);
  -o-animation-name: move-shine;
  -o-animation-duration: 2s;
  -o-animation-iteration-count: infinite;
}

/*  */
@keyframes move-shine {
  0% {
    left: -16px;
    opacity: 0;
  }
  1% {
    left: 0px;
    opacity: 0;
  }
  2% {
    opacity: 0.4;
  }
  10% {
    opacity: 0.4
  }
  90% {
    opacity: 0.2
  }
  100% {
    left: calc(100% + 4px)
  }
}

.banner-title {
  filter: drop-shadow(0px 0px 10.433px rgba(0, 0, 0, 0.66));
}

.scale-up {
  animation: scale-up 0.75s ease infinite alternate;
}

@keyframes scale-up {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.03);
  }
}

.blink-in-out {
  animation: blink-in-out 0.75s ease-in-out infinite;
}

@keyframes blink-in-out {
  0% {
    opacity: 0; /* Start completely invisible */
  }
  30% {
    opacity: 1; /* Fade in */
  }
  70% {
    opacity: 1; /* Fade in */
  }
  90% {
    opacity: 0; /* Stay fully visible */
  }
  100% {
    opacity: 0; /* Fade out */
  }
}

.live-chip-border {
  background: linear-gradient(#B1CCA8, rgba(255, 255, 255, 0));
}

.ticket-transform {
  transform: translate(-50%, -50%) rotate(-22deg);
}

.banner-container {
  background: linear-gradient(
    90.15deg,
    rgba(99, 91, 255, 0.1) -8.43%,
    rgba(220, 65, 251, 0.1) 83.79%,
    rgba(255, 112, 150, 0.1) 97.59%
  ); /* transparent background color */
  border-radius: 13px;
}

.banner-container::before {
  background: radial-gradient(ellipse at top, rgba(255, 255, 255, 38%), transparent),
  radial-gradient(ellipse at bottom, #2AA683, transparent);
  border-radius: 13px;
  content: "";
  inset: 0;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  padding: 2px; /* this is the border width */
  position: absolute;
  z-index: 10;
  pointer-events: none;
}
</style>
